import {
  cnaeSchema,
  type EmpresaDetalhe,
  inscricaoEstadualSchema,
  regimeVigenciaSchema,
  ufSchema,
} from '@fiscoai/contracts';

import { useSubstituirLista } from './api';
import { ListaEditavel } from './lista-editavel';
import { opcoesDe, REGIME } from './rotulos';

const UFS = ufSchema.options.map((uf) => ({ valor: uf, rotulo: uf }));
const hoje = () => new Date().toISOString().slice(0, 10);

/** Regime com vigência, inscrições estaduais por UF e CNAEs — o que muda o tratamento das notas. */
export function AbaTributario({
  empresa,
  podeEditar,
}: {
  empresa: EmpresaDetalhe;
  podeEditar: boolean;
}) {
  const regimes = useSubstituirLista(empresa.id, 'regimes');
  const inscricoes = useSubstituirLista(empresa.id, 'inscricoes-estaduais');
  const cnaes = useSubstituirLista(empresa.id, 'cnaes');
  return (
    <div>
      <ListaEditavel
        titulo="Regime tributário"
        descricao="Cada nota é avaliada pelo regime vigente na data dela. Ao mudar de regime, encerre o anterior e abra o novo."
        item={regimeVigenciaSchema}
        colunas={[
          {
            nome: 'regime',
            rotulo: 'Regime',
            tipo: 'select',
            opcoes: opcoesDe(REGIME),
            largura: 'w-52',
          },
          { nome: 'inicio', rotulo: 'Início', tipo: 'data' },
          { nome: 'fim', rotulo: 'Fim (vazio = vigente)', tipo: 'data' },
        ]}
        valores={empresa.regimes}
        novoItem={{ regime: 'LUCRO_REAL', inicio: hoje(), fim: null }}
        podeEditar={podeEditar}
        salvar={(itens) => regimes.mutateAsync(itens)}
        salvando={regimes.isPending}
      />
      <ListaEditavel
        titulo="Inscrições estaduais"
        descricao="Uma por UF. Substituto tributário quando a empresa recolhe ST para outra UF."
        item={inscricaoEstadualSchema}
        colunas={[
          { nome: 'uf', rotulo: 'UF', tipo: 'select', opcoes: UFS, largura: 'w-24' },
          { nome: 'inscricao', rotulo: 'Inscrição (ou ISENTO)', tipo: 'texto', mono: true },
          {
            nome: 'tipo',
            rotulo: 'Tipo',
            tipo: 'select',
            opcoes: [
              { valor: 'NORMAL', rotulo: 'Normal' },
              { valor: 'SUBSTITUTO_TRIBUTARIO', rotulo: 'Substituto tributário' },
            ],
            largura: 'w-52',
          },
        ]}
        valores={empresa.inscricoesEstaduais}
        novoItem={{ uf: 'BA', inscricao: '', tipo: 'NORMAL' }}
        podeEditar={podeEditar}
        salvar={(itens) => inscricoes.mutateAsync(itens)}
        salvando={inscricoes.isPending}
      />
      <ListaEditavel
        titulo="CNAEs"
        descricao="Atividades da empresa. Marque a principal."
        item={cnaeSchema}
        colunas={[
          {
            nome: 'codigo',
            rotulo: 'Código (7 números)',
            tipo: 'texto',
            mono: true,
            largura: 'w-40',
          },
          { nome: 'descricao', rotulo: 'Descrição', tipo: 'texto', largura: 'w-72' },
          { nome: 'principal', rotulo: 'Principal', tipo: 'marcador' },
        ]}
        valores={empresa.cnaes}
        novoItem={{ codigo: '', descricao: null, principal: empresa.cnaes.length === 0 }}
        podeEditar={podeEditar}
        salvar={(itens) => cnaes.mutateAsync(itens)}
        salvando={cnaes.isPending}
      />
    </div>
  );
}
